// cache previously loaded images. If the value is a promise we are still loading.
// otherwise the value will be the url of the loaded image on the client.
const promiseCache: Map<string, Promise<any> | any> = new Map();

export function useSuspendingFileCache<T>(
  url: string,
  getRequestPromise: (url: string) => Promise<T>,
  fallback?: T
): {
  result: T;
  clearResult: () => void;
} {
  if (!promiseCache.has(url)) {
    const fetchPromise = async () => {
      try {
        const result = await getRequestPromise(url);
        promiseCache.set(url, result);
        return result;
      } catch (error) {
        // throwing from an async function doesn't end up in the console. This makes sure it shows up
        console.error({ error });
        promiseCache.set(url, fallback);
        throw error;
      }
    };

    promiseCache.set(url, fetchPromise());
  }
  const cacheResult = promiseCache.get(url);
  if (cacheResult instanceof Promise) {
    // suspend by throwing a promise. Image is still loading
    throw cacheResult;
  }
  return {
    result: cacheResult as T,
    clearResult: () => promiseCache.set(url, undefined),
  };
}
